import React, { Component } from "react";
import WorldMap from "react-world-map";
import "./ModalSubmitAnswer.scss";

export default class ClickableMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eu: "Europe",
      na: "North America",
      sa: "South America",
      af: "Africa",
      as: "Asia",
      oc: "Oceania",

      correctAnswer: false
    };
  }

  getEvent = event => {
    // This functions adds the className map-disableAfterClick to the div with the same id. This will make the
    // map unclickable after one click.
    document.getElementById("map-disableAfterClick").className =
      "map-disableAfterClick";

    let continent = event.detail.clickedState;

    if (this.props.answered === false) {
      if (this.props.compare(this.state[continent]) === true) {
        this.setState({ correctAnswer: true });
      } else {
        this.setState({ correctAnswer: false });
      }

      this.props.handleAnswer();
      this.forceUpdate(); //Forces a re-render of the component
    }
  };

  //Lifecycle-method from React. If this method returns false, the component ClickableMap will not re-render.
  shouldComponentUpdate() {
    return this.props.answered;
  }

  componentDidMount() {
    window.addEventListener("WorldMapClicked", this.getEvent);
    //this.setState({ answered: false });
  }

  componentWillUnmount() {
    window.removeEventListener("WorldMapClicked", this.getEvent);
  }

  render() {
    return (
      <div>
        <div id="map-disableAfterClick">
          <WorldMap />
        </div>

        <div className="world-map-subtext">
          {this.state.correctAnswer && (
            <div>
              <h1 style={{ color: "green" }}>Correct!</h1>
              <h4>
                It was{" "}
                <span style={{ fontWeight: 600 }}>
                  {this.props.currentCoordinates.continent}{" "}
                </span>
                . Well done!
              </h4>
            </div>
          )}

          {!this.state.correctAnswer && this.props.answered && (
            <div>
              <h1 style={{ color: "red" }}>Incorrect!</h1>
              <h4>
                The correct answer was{" "}
                <span style={{ fontWeight: 600 }}>
                  {this.props.currentCoordinates.continent}.
                </span>
              </h4>
            </div>
          )}
        </div>
      </div>
    );
  }
}
